export const symbol = '₴';

export const formatMoney = (number: bigint, withSymbol = true): string => {
  const decimalValue = convertToDecimal(number).toString();

  const regex = /\B(?=(?:\d{3})+(?!\d))/g;
  const stringWithSpaces = decimalValue.replace(regex, ' ');

  let formattedMoney = stringWithSpaces;
  if (withSymbol) {
    formattedMoney = `${stringWithSpaces} ${symbol}`;
  }

  return formattedMoney;
};

export const convertToDecimal = (number: bigint, fraction = 0): number => {
  const valueInDecimal = number / BigInt(100);
  const formattedValue = parseFloat(valueInDecimal.toString()).toFixed(
    fraction,
  );

  return Number(formattedValue);
};

export const convertToCents = (number: number): bigint => {
  return BigInt(Math.round(number * 100));
};
